<div id="modal" class="modal" [ngClass]="classes" #modalElement>

  <div class="modal-dialog">

    <div class="modal-content">
      <button
        *ngIf="closeButtonEnabled"
        type="button"
        class="btn-close"
        data-dismiss="modal"
        (click)="onClose()"
        play-audio
        onClickSound="btn_close_click"
      >
        &times;
      </button>

      <ng-template #dialogComponent></ng-template>

    </div>
  </div>

  <div class="modal-backdrop" (click)="onClose()"></div>

</div>
